import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

const InventoryManagement = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  Layout: lazyNamed(() => import('./containers/Layout.tsx'), 'Layout'),
  Stock: lazyNamed(() => import('./containers/Stock/index.tsx'), 'StockTable'),
  Dispatch: {
    New: lazyNamed(() => import('./containers/Dispatches/index.ts'), 'DispatchTable'),
    Layout: lazyNamed(() => import('./containers/Dispatches/Layout.tsx'), 'Layout'),
  },
  SendDispatch: {
    Form: lazyNamed(() => import('./containers/SendDispatch/index.tsx'), 'SendDispatch'),
    Layout: lazyNamed(() => import('./containers/SendDispatch/components/Layout.tsx'), 'Layout'),
  },
};
export default InventoryManagement;
